import React, { useState } from 'react'
import { resendVerification } from '../../services/auth'
import Logo from '../../components/Logo'
import Button from '../components/Button'
import Link from '../components/Link'

const ResendVerification: React.FC = () => {
  const [email, setEmail] = useState('')
  const [loading, setLoading] = useState(false)
  const [message, setMessage] = useState<{
    type: 'success' | 'error'
    text: string
  } | null>(null)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setMessage(null)
    setLoading(true)

    try {
      const response = await resendVerification(email)
      setMessage({
        type: 'success',
        text: response.message,
      })
      setEmail('')
    } catch (error: any) {
      setMessage({
        type: 'error',
        text:
          error.response?.data?.error ||
          'Failed to send verification email. Please try again.',
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div className="flex flex-col items-center">
          <Logo />
          <h3 className="mt-6 text-center text-2xl font-extrabold text-gray-900">
            Resend Verification Email
          </h3>
          <p className="mt-2 text-center text-sm text-gray-600">
            Enter your email address and we'll send you a new verification link
          </p>
        </div>

        <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
          {message && (
            <div
              className={`${
                message.type === 'success'
                  ? 'bg-green-50 border-green-200 text-green-700'
                  : 'bg-red-50 border-red-200 text-red-700'
              } border px-4 py-3 rounded`}
            >
              {message.text}
            </div>
          )}

          <div>
            <label htmlFor="email" className="sr-only">
              Email address
            </label>
            <input
              id="email"
              name="email"
              type="email"
              autoComplete="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500 focus:z-10 sm:text-sm"
              placeholder="Email address"
            />
          </div>

          <div>
            <Button type="submit" variant="primary" fullWidth loading={loading}>
              {loading ? 'Sending...' : 'Send Verification Email'}
            </Button>
          </div>

          <div className="text-center space-y-2">
            <Link to="/login" className="text-sm">
              Back to login
            </Link>
          </div>
        </form>
      </div>
    </div>
  )
}

export default ResendVerification
